import styles from './BasicTitle.module.scss';
import { useEffect, useRef } from 'react';
import { gsap, Power4 } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const tweenVars = [
  {
    y: '50',
    duration: 0.7,
    opacity: 0,
    ease: Power4.easeOut,
  },
  {
    x: '-50',
    duration: 0.5,
    opacity: 0,
    ease: Power4.easeOut,
  },
];

interface Props {
  sectionTitle: {
    title: string;
    sub_title: string;
  };
  adjust?: string;
}

const TitleFlex: React.FC<Props> = ({ sectionTitle, adjust = '' }) => {
  const timeline = gsap.timeline();
  const title = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (title.current) {
      const children = title.current.querySelectorAll('span');

      gsap.set(children, { opacity: 0 });

      timeline
      .fromTo(
        children[0],
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1.0, ease: Power4.easeOut },
        0
      )
      .fromTo(
        children[1],
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1.0, ease: Power4.easeOut },
        0.3
      );

      ScrollTrigger.create({
        animation: timeline,
        trigger: title.current,
        start: 'top 90%',
        toggleActions: 'play none none play',
      });
    }
  }, []);

  const titleClassName = adjust ? `${styles.title} ${styles[adjust]}` : styles.title;

  return (
    <h2 className={titleClassName} ref={title}>
      <span className={styles.title_en}>{sectionTitle.title}</span>
      <span className={styles.title_ja}>{sectionTitle.sub_title}</span>
    </h2>
  );
};

export default TitleFlex;
